module.exports = __webpack_public_path__ + "static/img/4areaA_4.8f77b98.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_4.png
// module id = 902
// module chunks = 1